/**
 * @generated SignedSource<<14b69ddb4bdbf065a5b16618d21b541b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HighLevelTimeNumbers_company$data = {
  readonly id: string;
  readonly " $fragmentType": "HighLevelTimeNumbers_company";
};
export type HighLevelTimeNumbers_company$key = {
  readonly " $data"?: HighLevelTimeNumbers_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"HighLevelTimeNumbers_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighLevelTimeNumbers_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "650e7e75b816b0631475bba318dff414";

export default node;
